import React from 'react';
import { useState, useEffect } from 'react';
import NavigationBar from '../navigations/NavigationBar';
import OrdersOperations from './OrdersOperations';
import FixedContainer from '../data_input/FixedContainer';

const HomePage = ({
  currentOrders, 
  updateCurrentOrders, 
  handleCurrentRunningOrders,
  assistantPassword,
  clientInfo,
  handleClientInfo,
  percentage,
  employeesAndvehicles,
  handleEmployerAndvehicle
}) => {
  const [currentContainer, setCurrentContainer] = useState('');
  const [notes, setNotes] = useState('');

  useEffect(() => {
    
  if (sessionStorage.notes) {
    setNotes(
      JSON.parse(sessionStorage.notes)
    )
  }
  }, [])

  const updateemployeesAndvehicles = (newemployees, newvehicles) => {
    const newEM = {...employeesAndvehicles};
    newEM.employees = newemployees ? newemployees : newEM.employees
    newEM.vehicles = newvehicles ? newvehicles : newEM.vehicles
    handleEmployerAndvehicle(newEM);
  }

  const handleCurrentContainer = (name) => {
    setCurrentContainer(name);
  }

  const handleFinishedOrders = (orders) => {
    let newCurrentOrders = [...currentOrders].map((o) => {
      for (let order of orders) {
        if (order.id === o.id) {
          o.state = 'end'
        }
      }
      return o
    });

    updateCurrentOrders(newCurrentOrders)
  }

  const handleNotes = (action) => {
    let newNotes = [...notes];

    switch (action.type) {
      case 'add':
        newNotes.unshift(action.newNote);
        break;
      case 'remove':
        newNotes = newNotes.filter((note) => note.id !== action.id)
        break;
      default:
    }

    setNotes(newNotes);
    sessionStorage.notes = JSON.stringify(newNotes)
  }

  const updateClientInfo = (data) => {
    
    handleClientInfo(data)
  }

  return (
    <div className='home-page'>
      <NavigationBar 
        handleCurrentContainer={handleCurrentContainer}
        notes={notes}
      />
      <OrdersOperations 
        employees={employeesAndvehicles.employees}
        vehicles={employeesAndvehicles.vehicles}
        updateemployeesAndvehicles={updateemployeesAndvehicles}
        handleFinishedOrders={handleFinishedOrders}
        currentOrders={currentOrders}
        setCurrentOrders={(x) => updateCurrentOrders(x)}
        handleCurrentRunningOrders={handleCurrentRunningOrders}
        clientInfo={clientInfo}
        updateClientInfo={updateClientInfo}
      />
      {currentContainer && <FixedContainer 
        employees={employeesAndvehicles.employees}
        vehicles={employeesAndvehicles.vehicles}
        currentContainer={currentContainer}
        handleCurrentContainer={handleCurrentContainer}
        updateemployeesAndvehicles={updateemployeesAndvehicles}
        handleFinishedOrders={handleFinishedOrders}
        notes={notes}
        handleNotes={handleNotes}
        currentOrders={currentOrders}
        assistantPassword={assistantPassword}
        percentage={percentage}
        />}
    </div>
  )
}

export default HomePage;